import DieciWebshopService from './DieciWebshopService'
import DieciWebshopServiceMock from './DieciWebshopServiceMock'
import DieciContaoService from './DieciContaoService'
import DieciContaoServiceMock from './DieciContaoServiceMock'
import { config } from '@/config'

const tmpService = new DieciContaoService()
const tmpContaoService = new DieciContaoService()

updateServiceConfig()

export const service = tmpService
export const contaoService = tmpContaoService

export function updateServiceConfig () {
  tmpService.endpoint = config.WEBSHOP_ENDPOINT
  tmpContaoService.endpoint = config.WEBSHOP_CONTAO_ENDPOINT

  if (config.MOCK && tmpService.mock == null) {
    tmpService.mock = new DieciWebshopServiceMock()
    tmpContaoService.mock = new DieciContaoServiceMock()
  } else if (!config.MOCK) {
    tmpService.mock = null
    tmpContaoService.mock = null
  }
}
